const axios = require('axios');

const ENV = process.env;

export default class ProfileService {
  static parseProfile(profile) {
    const userProfile = {};
    userProfile.avatar = profile.avatar || 'https://cdn.flixel.com/static/static-web/misc/avatar.png';
    userProfile.realname = profile.realname || profile.username;
    userProfile.url = profile.url;
    userProfile.description = profile.description;
    userProfile.marketing_consent = profile.marketing_consent;
    userProfile.tracking_consent = profile.tracking_consent;
    return userProfile;
  }

  static get(name) {
    const self = this;
    return new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: ENV.api + '/users/' + name,
      })
        .then(function success(data) {
          const profile = self.parseProfile(data.data);
          resolve(profile);
        })
        .catch(function error(data) {
          reject(data);
        });
    });
  }

  static update(formData) {
    const self = this;
    return new Promise(function (resolve, reject) {
      axios({
        method: 'PATCH',
        url: ENV.api + '/profile/',
        headers: { 'Content-Type': undefined },
        data: formData,
      })
        .then(function success(data) {
          const profile = self.parseProfile(data.data);
          resolve(profile);
        })
        .catch(function error(errorMessage) {
          reject(errorMessage);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/profile.es6.js